"use client"
import React, { useEffect, useState } from 'react'
import style from "./style.module.css"
import Link from 'next/link'

/* eslint-disable @next/next/no-img-element */
function GetappClient() {
    const [query, setQuery] = useState('');

    useEffect(() => {
        if (typeof window !== "undefined" && window.location.href) {
            setQuery(window.location.href.replace('https://dramasstory.com/', '').replace('https://dramaflicksapp.com/', ''))
        }
    }, []);

    const handleWatchNowClick = async () => {
        const currentUrl = window.location.href;

        try {
            // THIS IS THE PRIMARY AND MOST RELIABLE METHOD ON MODERN BROWSERS (REQUIRES HTTPS!)
            await navigator.clipboard.writeText(currentUrl);
        } catch (err) {
            console.error('Failed to copy using Clipboard API:', err);
            // FALLBACK: less reliable, but might work in some edge cases or older browsers
            const textArea = document.createElement('textarea');
            textArea.value = currentUrl;
            textArea.style.position = 'fixed';
            textArea.style.left = '-9999px';
            textArea.style.top = '-9999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select(); // Essential for execCommand
            try {
                document.execCommand('copy');
            } catch (execErr) {
                console.error('document.execCommand("copy") failed:', execErr);
            } finally {
                document.body.removeChild(textArea);
            }
        }
    };
    return (
        <>
            <div className={style.bannerSec} style={{ backgroundImage: "url('https://dramasstory.fra1.cdn.digitaloceanspaces.com/web_images/banner.webp')", backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover" }}>
                <div className="container">
                    <div className={style.getappMain}>
                        <div className={style.bannerOuter}>
                            <h1 className={style.DkShow}>
                                Binge the Best Short Dramas on DramaFlicks.<span>Scan the QR code to download the app now.</span>
                            </h1>
                            <h1 className={style.MobileShow}>
                                Get DramaFlicks app <span>Tap download & unlock endless entertainment.</span>
                            </h1>
                        </div>
                        <div className={style.getApp}>
                            <Link onClick={handleWatchNowClick} href={`https://dramaflicksapp.com/getapp.php?utm_source=website&utm_medium=mobile&utm_campaign=downloadbutton&q=${query}`} className={style.commonBtnGetapp}>
                                Download App
                            </Link>
                        </div>
                        <div className={style.getAppScanner}>
                            <img src="scannerGetapp.webp" alt="scannerGetapp" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GetappClient